import Vue from "vue";
import { VueAuthenticate } from "vue-authenticate";
import providers from "Services/providers";
const vueAuth = new VueAuthenticate(Vue.prototype.$http, providers);
import swal from "sweetalert2";

const state = {
  me: null,
  isAuthenticated: false
};

const getters = {
  getMe: state => state.me,
  isAuthenticated: () => vueAuth.isAuthenticated()
};

const actions = {
  /* Tested Working */
  /* form : name, email ,password, password_confirmation */
  async register({ commit, dispatch }, form) {
    form.busy = true;
    try {
      await vueAuth.register(form).then(() => {
        commit("isAuthenticated", {
          isAuthenticated: vueAuth.isAuthenticated()
        });
      });

      await dispatch("fetchMe");

      form.busy = false;
      vm.$router.push({ name: "dashboard" });
    } catch ({ errors, message }) {
      form.errors.set(errors);
      form.busy = false;
    }
  },
  /* Tested Working */
  /* form : username ,password */
  async login({ commit, dispatch }, form) {
    form.busy = true;
    try {
      await vueAuth.login(form).then(() => {
        commit("isAuthenticated", {
          isAuthenticated: vueAuth.isAuthenticated()
        });
      });

      await dispatch("fetchMe");

      form.busy = false;
      vm.$router.push({ name: "dashboard" });
    } catch (error) {
      form.errors.set(error.response.data.errors);
      form.busy = false;
      let modal = swal.mixin({
        confirmButtonClass: "v-btn blue-grey  subheading white--text",
        buttonsStyling: false
      });
      if (error.response.status === 400) {
          modal.fire({
              title: `Credentiale incorecte`,
              html: `<p class="title">Credentialele introduse nu sunt valide. Va rugam verificati combinatia de utilizator/e-mail si parola.</p>`,
              type: "error",
              confirmButtonText: "Back"
          });
      } else if (error.response.status === 401) {
        modal.fire({
          title: `${error.response.data.error}`,
          html: `<p class="title">${error.response.data.message}</p>`,
          type: "error",
          confirmButtonText: "Back"
        });
      }
    }
  },
  /* form : name,email ,provider(fb),provider_user_id(fb_id) */
  async socialauth({ commit, dispatch }, form) {
    form.busy = true;
    try {
      await App.post(route("api.auth.social"), form).then(() => {
        commit("isAuthenticated", {
          isAuthenticated: vueAuth.isAuthenticated()
        });
      });

      await dispatch("fetchMe");
      form.busy = false;

      vm.$router.push({ name: "dashboard" });
    } catch ({ errors, message }) {
      form.errors.set(errors);
      form.busy = false;
    }
  },
  /* Tested Working */
  /* Remove Access Token Cookie */
  async logout({ commit }, form) {
    form.busy = true;
    try {
      await vueAuth.logout().then(() => {
        commit("isAuthenticated", {
          isAuthenticated: vueAuth.isAuthenticated()
        });
        commit("setMe", null);
      });

      form.busy = false;
      vm.$router.push({ name: "index" });
    } catch ({ errors, message }) {
      form.busy = false;
    }
  },
  /* Tested Working */
  /* Get User Profile , Roles and Permissions */
  async fetchMe({ commit, dispatch }) {
    try {
      let payload = await axios.post(route("api.@me"));
      commit("setMe", payload.data);
      vm.$root.$emit('accessChanged', payload.data?.roles)
    } catch ({ errors, message }) {
      if (errors) {
        console.log(errors);
      }
      if (message) {
        console.log(message);
      }
    }
  },
  /* Tested Working */
  /* form : username ,password, password_confirmation, token */
  async passwordreset({ commit, dispatch }, form) {
    form.busy = true;
    try {
      await form.post(route("api.auth.reset-password")).then(response => {
        commit("isAuthenticated", {
          isAuthenticated: vueAuth.isAuthenticated()
        });
        vueAuth.setToken(response)
      });
      await dispatch("fetchMe");
      vm.$router.push({ name: "dashboard" });
    } catch (error) {
      form.busy = false;
      if (error.response.status) {
        let modal = swal.mixin({
          confirmButtonClass: "v-btn blue-grey  subheading white--text",
          buttonsStyling: false
        });
        modal.fire({
          title: `${error.response.status} Error!`,
          html: `<p class="title">${error.response.data.message}</p>`,
          type: "error",
          confirmButtonText: "Back"
        });
      }
    }
  },
  //! Not working as expected only showing empty popup
  /* form : name,email ,provider(fb),provider_user_id(fb_id) */
  /* async oauthLogin ({ commit, dispatch,state }, { provider, form, redirectUri } = payload) {
        form.busy = true
        let user = state.me
        vueAuth.options.providers[provider].url = `/auth/${provider}/user/${user.id}/login`
        let requestOptions = {}
        requestOptions.method = 'POST'
        // vueAuth.options.providers[provider].redirectUri = redirectUri
        vueAuth.options.providers[provider].popupOptions = { width: 0, height: 0 }
        try {
            await vueAuth.authenticate(provider,form,requestOptions).then((response) => {
                console.log(response)
            })
            form.busy = false
            vm.$popup({ message: 'Successfully Logged In!', backgroundColor: '#4db6ac', delay: 5, color: '#fffffa' })
        } catch ({errors, message}) {
            form.errors.set(errors)
            form.busy = false
            vm.$popup({ message: message, backgroundColor: '#e57373', delay: 5, color: '#fffffa' })
        }
    }
    */
    async registerExternal({ commit, dispatch }, form) {
        form.busy = true;
        try {
            let needsEmailValidation = false
            await vueAuth.register(form).then((response) => {
                needsEmailValidation = response.status === 201
                if (!needsEmailValidation) {
                    commit("isAuthenticated", {
                        isAuthenticated: vueAuth.isAuthenticated()
                    });
                }
            });

            if (!needsEmailValidation) {
                await dispatch("fetchMe");
            } else {
                let successModal = swal.mixin({
                    confirmButtonClass: "ml-2 v-btn v-btn--contained theme--dark v-size--default primary",
                    buttonsStyling: false
                });
                successModal.fire({
                    title: "Success!",
                    html: `<p class="title">Va multumim pentru inregistrare! Pentru activarea contului va rugam sa urmati pasii care v-am trimis prin mail la adresa introdusa.</p>`,
                    type: "warning",
                    confirmButtonText: "Finalizare"
                });
            }

            form.busy = false;
            return true
        } catch (error) {
            form.errors.set(error.response.data.errors);
            form.busy = false;
        }
    },
    async loginExternal({ commit, dispatch }, form) {
        form.busy = true;
        try {
            await vueAuth.login(form).then(() => {
                commit("isAuthenticated", {
                    isAuthenticated: vueAuth.isAuthenticated()
                });
            });

            await dispatch("fetchMe");

            form.busy = false;
            return true
        } catch (error) {
            form.errors.set(error.response.data.errors);
            form.busy = false;
            let modal = swal.mixin({
                confirmButtonClass: "v-btn blue-grey  subheading white--text",
                buttonsStyling: false
            });
            if (error.response.status === 400) {
                modal.fire({
                    title: `Credentiale incorecte`,
                    html: `<p class="title">Credentialele introduse nu sunt valide. Va rugam verificati combinatia de utilizator/e-mail si parola.</p>`,
                    type: "error",
                    confirmButtonText: "Back"
                });
            } else if (error.response.status === 401) {
                modal.fire({
                    title: `${error.response.data.error}`,
                    html: `<p class="title">${error.response.data.message}</p>`,
                    type: "error",
                    confirmButtonText: "Back"
                });
            }
        }
    },
    async verifyExternal({ commit, dispatch }, data) {
        await axios.get(route("api.auth.verify"), {
            params: data
        })
        .then((response) => {
            let successModal = swal.mixin({
                confirmButtonClass: "ml-2 v-btn v-btn--contained theme--dark v-size--default primary",
                buttonsStyling: false
            });
            successModal.fire({
                title: "Success!",
                html: `<p class="title">Va multumim pentru inregistrare! Contul Dvs. a fost activat cu success!</p>`,
                type: "success",
                confirmButtonText: "Finalizare"
            });
        }).catch((error) => {
            let modal = swal.mixin({
                confirmButtonClass: "v-btn blue-grey  subheading white--text",
                buttonsStyling: false
            });
            modal.fire({
                title: `Eroare`,
                html: `<p class="title">${error.response.data.message}</p>`,
                type: "error",
                confirmButtonText: "Back"
            });
        })
    },
    async passwordresetExternal({ commit, dispatch }, form) {
        form.busy = true;
        try {
            await form.post(route("api.auth.reset-password")).then(response => {
                commit("isAuthenticated", {
                    isAuthenticated: vueAuth.isAuthenticated()
                });
                vueAuth.setToken(response)
            });
            await dispatch("fetchMe");
        } catch (error) {
            form.busy = false;
            if (error.response.status) {
                let modal = swal.mixin({
                    confirmButtonClass: "v-btn blue-grey  subheading white--text",
                    buttonsStyling: false
                });
                modal.fire({
                    title: `${error.response.status} Error!`,
                    html: `<p class="title">${error.response.data.message}</p>`,
                    type: "error",
                    confirmButtonText: "Back"
                });
            }
        }
    },
    async logoutExternal({ commit }) {
        try {
            await vueAuth.logout().then(() => {
                commit("isAuthenticated", {
                    isAuthenticated: vueAuth.isAuthenticated()
                });
                commit("setMe", null);
            });
        } catch ({ errors, message }) {
            // Do nothing
        } finally {
            window.location.reload()
        }
    }
};

const mutations = {
  setMe: (state, payload) => {
    state.me = payload;
  },
  isAuthenticated: (state, payload) => {
    state.isAuthenticated = payload.isAuthenticated;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
